import axios from "axios";
import { INSIDERODEO_EVENT_STORAGE, SELECTED_EVENT_STORAGE, STORAGE, URLS } from "../../_config";
import { clearSSOCookie } from "../../_common/utils/ssoCookie";

function handleUnauthorized() {
  localStorage.removeItem(STORAGE);
  localStorage.removeItem(SELECTED_EVENT_STORAGE);
  localStorage.removeItem(INSIDERODEO_EVENT_STORAGE);
  localStorage.removeItem("persist:root");
  clearSSOCookie();
  window.location.href = URLS.HOME;
}

export class CallApi {
  static GET(url, params, _isAuth, _isAdaptive) {
    return new Promise((resolve, reject) => {
      let headers = {};
      // if (isAuth || isAdaptive) {
      const token = localStorage.getItem(STORAGE);
      if (token) {
        headers = {
          Authorization: `Bearer ${token}`,
        };
      }
      // }
      return axios({
        method: "GET",
        url,
        headers,
        params,
      })
        .then((success) => {
          return resolve(success);
        })
        .catch((error) => {
          if (error.response && error.response.status === 401 && window.location.pathname !== URLS.AUTH.LOGIN) {
            handleUnauthorized();
          }
          return reject(error.response);
        });
    });
  }

  static POST(url, data, isAuth, isAdaptive) {
    return new Promise((resolve, reject) => {
      let headers = {};
      if (isAuth || isAdaptive) {
        const token = localStorage.getItem(STORAGE);
        if (token) {
          headers = {
            Authorization: `Bearer ${token}`,
          };
        }
      }
      return axios({
        method: "POST",
        url,
        headers,
        data,
      })
        .then((success) => {
          return resolve(success);
        })
        .catch((error) => {
          if (error.response && error.response.status === 401 && window.location.pathname !== URLS.AUTH.LOGIN) {
            handleUnauthorized();
          }
          return reject(error.response);
        });
    });
  }

  static PUT(url, data, isAuth, isAdaptive) {
    return new Promise((resolve, reject) => {
      let headers = {};
      if (isAuth || isAdaptive) {
        const token = localStorage.getItem(STORAGE);
        if (token) {
          headers = {
            Authorization: `Bearer ${token}`,
          };
        }
      }
      return axios({
        method: "PUT",
        url,
        headers,
        data,
      })
        .then((success) => {
          return resolve(success);
        })
        .catch((error) => {
          if (error.response && error.response.status === 401 && window.location.pathname !== URLS.AUTH.LOGIN) {
            handleUnauthorized();
          }
          return reject(error.response);
        });
    });
  }

  static DELETE(url, data, isAuth, isAdaptive) {
    return new Promise((resolve, reject) => {
      let headers = {};
      if (isAuth || isAdaptive) {
        const token = localStorage.getItem(STORAGE);
        if (token) {
          headers = {
            Authorization: `Bearer ${token}`,
          };
        }
      }
      return axios({
        method: "DELETE",
        url,
        headers,
        data,
      })
        .then((success) => {
          return resolve(success);
        })
        .catch((error) => {
          if (error.response && error.response.status === 401 && window.location.pathname !== URLS.AUTH.LOGIN) {
            handleUnauthorized();
          }
          return reject(error.response);
        });
    });
  }
}
